import React from "react";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";

const sendLogsAPI = async () => {
  const pendingAccessLogs = JSON.parse(
    localStorage.getItem("pendingAccessLogs")
  );

  await Api.post("set-log-access", "log", pendingAccessLogs, true)
    .then((value) => {
      if (value?.Success) {
        localStorage.setItem("dateLastSendLogsAPI", JSON.stringify(new Date()));
        localStorage.setItem("pendingAccessLogs", JSON.stringify({ logs: [] }));
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const sendLogsAPIProblemScreen = async () => {
  const pendingLogsProblems = JSON.parse(
    localStorage.getItem("pendingLogsProblems")
  );

  await Api.post("set-log-access", "log", pendingLogsProblems, true)
    .then((value) => {
      if (value?.Success) {
        localStorage.setItem(
          "pendingLogsProblems",
          JSON.stringify({ logs: [] })
        );
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const verifyTimeSendLogs = () => {
  let result = false;
  const lastSendLogsAPI = localStorage.getItem("dateLastSendLogsAPI");

  if (lastSendLogsAPI) {
    const dtlastreq = new Date(JSON.parse(lastSendLogsAPI));
    const dtNow = new Date();
    const diffMs = dtNow - dtlastreq; // milliseconds between now & dtlastreq
    const diffMins = Math.round(diffMs / 60000); // minutes

    if (diffMins >= 30) {
      result = true;
    }
  } else {
    localStorage.setItem("dateLastSendLogsAPI", JSON.stringify(new Date()));
  }

  return result;
};

const Logs = () => {
  const setLocalStorageActions = React.useCallback(
    ({ nomeTela, idMenu, acao }) => {
      if (localStorage.getItem("pendingAccessLogs") === null) {
        localStorage.setItem("pendingAccessLogs", JSON.stringify({ logs: [] }));
      }

      const pendingAccessLogs = JSON.parse(
        localStorage.getItem("pendingAccessLogs")
      );

      pendingAccessLogs.logs.push({
        idMenu: idMenu,
        tela: nomeTela,
        sistema: "PORTALB2B",
        dataAcesso: MaskAndValid.formattDateHourAPI(new Date()),
        acao: acao,
      });

      localStorage.setItem(
        "pendingAccessLogs",
        JSON.stringify(pendingAccessLogs)
      );

      if (pendingAccessLogs?.logs?.length >= 100 || verifyTimeSendLogs()) {
        sendLogsAPI();
      }
    },
    []
  );

  const setLocalStorageApiProblem = React.useCallback(
    ({ idMenuAccess, screen, problem }) => {
      if (localStorage.getItem("pendingLogsProblems") === null) {
        localStorage.setItem(
          "pendingLogsProblems",
          JSON.stringify({ logs: [] })
        );
      }

      const pendingLogsProblems = JSON.parse(
        localStorage.getItem("pendingLogsProblems")
      );

      const dataAcesso = MaskAndValid.formattDateHourAPI(new Date());

      pendingLogsProblems.logs.push({
        idMenu: idMenuAccess,
        tela: screen,
        sistema: "PORTALB2B",
        dataAcesso: dataAcesso,
        acao: problem,
      });

      localStorage.setItem(
        "pendingLogsProblems",
        JSON.stringify(pendingLogsProblems)
      );

      if (pendingLogsProblems?.logs?.length !== 0) {
        sendLogsAPIProblemScreen();
      }
    },
    []
  );

  const setLocalStorageLoginAccess = React.useCallback((KIdUser) => {
    if (localStorage.getItem("pendingAccessLogs") === null) {
      localStorage.setItem("pendingAccessLogs", JSON.stringify({ logs: [] }));
    }

    const pendingAccessLogs = JSON.parse(
      localStorage.getItem("pendingAccessLogs")
    );

    const kIdUser = KIdUser;
    const sistema = "PORTALB2B";
    const dataAcesso = MaskAndValid.formattDateHourAPI(new Date());
    const acao = "Realizou login";
    const userDevice = window?.navigator?.userAgent;

    pendingAccessLogs.logs.push({
      kIdUser: kIdUser,
      device: userDevice,
      sistema: sistema,
      dataAcesso: dataAcesso,
      acao: acao,
      indLogin: true,
    });

    localStorage.setItem(
      "pendingAccessLogs",
      JSON.stringify(pendingAccessLogs)
    );

    if (pendingAccessLogs?.logs?.length >= 100 || verifyTimeSendLogs()) {
      sendLogsAPI();
    }
  }, []);

  return {
    setLocalStorageActions,
    setLocalStorageApiProblem,
    setLocalStorageLoginAccess,
  };
};

export default Logs;
